export default "__VITE_ASSET__B5uy4pdC__"